import * as types from '../../action-types';

export default sessionData => ({
  type: types.SET_NEWPAY_SESSION_DATA,
  sessionData,
});
